import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TicketService } from 'src/app/services/ticket.service';
/**
 * @ignore
 * @deprecated
 */
@Component({
  selector: 'app-sign-up-edit',
  templateUrl: './sign-up-edit.component.html',
  styleUrls: ['./sign-up-edit.component.scss']
})
export class SignUpEditComponent {
  finishedLoading: boolean = false;

  infoForm: UntypedFormGroup;
  contactForm: UntypedFormGroup;
  personFrom: UntypedFormGroup;
  addressFrom: UntypedFormGroup;
  commentForm: UntypedFormGroup;
  measuredValuesForm: UntypedFormGroup;
  supplyContractForm: UntypedFormGroup;

  is
  constructor(
    private route: ActivatedRoute,
    private ticketService: TicketService,
    private fb: UntypedFormBuilder) {

    this.infoForm = this.fb.group({
      state: ['', []],
      created: ['', []],
      lastModified: ['', []],
      creator: ['', []]
    })

    this.personFrom = this.fb.group({
      accountRef: ['', []],
      title: ['', []],
      firstName: ['', []],
      lastName: ['', []],
      gender: ['', []],
      birthday: ['', []],
      create: ['', []],
      lastModified: ['', []],
    });

    this.contactForm = this.fb.group({
      phone: ['', []],
      phoneMobile: ['', []],
      email: ['', []],
    });

    this.addressFrom = this.fb.group({
      city: ['', []],
      postcode: ['', []],
      street: ['', []],
    });

    this.measuredValuesForm = this.fb.group({
      measuredValueGas: this.fb.group({
        measuredAt: ['', []],
        number: ['', []],
        tariff: ['', []],
        type: ['', []],
        value: ['', []],
        valueNT: ['', []],
      }),
      measuredValueHeat: this.fb.group({
        measuredAt: ['', []],
        number: ['', []],
        tariff: ['', []],
        type: ['', []],
        value: ['', []],
        valueNT: ['', []],
      }),
      measuredValuePower: this.fb.group({
        measuredAt: ['', []],
        number: ['', []],
        tariff: ['', []],
        type: ['', []],
        value: ['', []],
        valueNT: ['', []],
      }),
      measuredValueWater: this.fb.group({
        measuredAt: ['', []],
        number: ['', []],
        tariff: ['', []],
        type: ['', []],
        value: ['', []],
        valueNT: ['', []],
      })
    })

    this.commentForm = this.fb.group({
      comment: ['', []],
    })

    this.supplyContractForm= this.fb.group({
      validFrom: ['', []],
    })



  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.ticketService.getTicketById(params['tid']).subscribe({
        next: ticket => {
          let obj = JSON.parse(ticket['summary']);
          this.finishedLoading = true;
          console.log(ticket)
          console.log(obj)
          this.infoForm.patchValue({
            state: ticket['state'],
            created: this.formatDate(new Date(ticket['created'])),
            lastModified: this.formatDate(new Date(ticket['lastModified']))
          })
          this.infoForm.disable();

          this.personFrom.patchValue(obj['person'])
          this.personFrom.disable();

          if (obj['phone'] != null) {
            this.contactForm.patchValue({
              phone: obj['phone'].channelData,
              phoneMobile: obj['phoneMobile'].channelData,
              email: obj['email'].channelData
            });
            this.contactForm.disable();
          } else {
            this.contactForm.disable();
          }


          this.addressFrom.patchValue({
            city: obj['address'].city,
            postcode: obj['address'].postcode,
            street: obj['address'].street,
          });
          this.addressFrom.disable();

          if(obj['supplyContract']){
            this.supplyContractForm.patchValue({
              validFrom : this.formatDate(new Date(obj['supplyContract']['validFrom']))
            })
            this.supplyContractForm.disable();
          }
  

          this.measuredValuesForm.patchValue(obj);
          this.measuredValuesForm.disable();

          this.commentForm.patchValue(obj);
          this.commentForm.disable();
        }, error: err => {
          console.error(err)
        }
      })
    })
  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }
}
